export type RemoveReason = "expired" | "used_on_scene" | "missing" | "reset_item";

export const REMOVE_REASON_OPTIONS: Array<{ value: RemoveReason; label: string }> = [
  { value: "expired", label: "Expired" },
  { value: "used_on_scene", label: "Used on incident" },
  { value: "missing", label: "Missing" },
  { value: "reset_item", label: "Reset item" }
];

export const TRUCK_CHECK_REMOVE_REASON_OPTIONS = REMOVE_REASON_OPTIONS.filter((option) => option.value !== "used_on_scene");

export function removeReasonLabel(reason: RemoveReason | "" | null | undefined): string {
  return REMOVE_REASON_OPTIONS.find((option) => option.value === reason)?.label ?? "";
}

export function actionReasonAuditNote(reason: RemoveReason | "" | null | undefined): string | null {
  const label = removeReasonLabel(reason);
  return label ? `Reason: ${label}` : null;
}

export function removeReasonAuditNote(reason: RemoveReason | "" | null | undefined): string | null {
  const label = removeReasonLabel(reason);
  return label ? `Remove reason: ${label}` : null;
}
